import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountsStore from '../../../stores/AccountsStore';
import AccountDetailsBL from './AccountDetailsBL';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import HelpActionCreator from '../../../actions/HelpActionCreator';
import AccountDropDownComponent from './AccountDropDownComponent';
import UserManagementStore from '../../../stores/UserManagementStore';
import envConfig from '../../../../static/config';
import { CreditCardText } from './CreditCardText';
import { AccountInfo } from './AccountInfo';
import { AERInformation } from './AERInformation';
import { PanelData } from './PanelData';

const isAccountChangedAllowed = () =>
  envConfig.isLcvEnabled ? !UserManagementStore.isSMEUser() : true;

/**
 * @todo rename to `AccountCard`
 */
class AccountCardComponent extends Component {
  constructor(props) {
    super(props);

    this.onFAQAnchorClick = this.onFAQAnchorClick.bind(this);
    this.showMore = this.showMore.bind(this);

    this.state = {
      collapsibleButtonName: props.collapsibleButtonName || 'More',
      iconId: props.iconId || 'icon-down',
      open: props.openMore || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.openMore !== this.props.openMore ||
      prevProps.collapsibleButtonName !== this.props.collapsibleButtonName ||
      prevProps.iconId !== this.props.iconId
    ) {
      this.setState(() => ({
        open: this.props.openMore,
        collapsibleButtonName: this.props.collapsibleButtonName,
        iconId: this.props.iconId,
      }));
    }
  }

  onFAQAnchorClick() {
    HelpActionCreator.backSetUrl(
      'WEB-ACCOUNT-DETAILS',
      this.props.content.anyQuestionURL
    );
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
  }

  showMore() {
    document.getElementById('ShowMore').focus();
    this.props.openCloseMore();
  }

  render() {
    const accountDetails = AccountsStore.getAccountDetail(this.props.accountId);
    const balances = AccountDetailsBL.getBalances(accountDetails);

    const regularSaver632 = accountDetails.product.code === '632';

    return (
      <div className="account-summary pos-r">
        {/* ---Account Info Left side---*/}
        <div className="account-summary__card">
          <dl>
            <dt>Account</dt>
            <dd className="account-summary__card__list">
              <AccountDropDownComponent
                selectedAccount={accountDetails}
                accountList={AccountsStore.getAccounts()}
                onAccountSelect={this.props.onAccountSelect}
                allowAccountChange={isAccountChangedAllowed()}
              />
            </dd>

            <dt>Account number &amp; sortcode</dt>
            <dd
              className="account-summary__card__sortcode cardsticky__hide"
              id="accountDetails"
            >
              <span className="u-visually-hidden off-screen">
                Sort Code and Account Number
              </span>
              {AccountDetailsBL.getAccountDisplayNumber(accountDetails)}
            </dd>

            {accountDetails.type === 'credit_card' && (
              <CreditCardText account={accountDetails} />
            )}
          </dl>
        </div>
        {/* ---Account Info Right side---*/}
        <AccountInfo
          account={accountDetails}
          balances={balances}
          accountInterestRegularSaverText={
            regularSaver632
              ? this.props.content.accountInterestRegularSaver632
              : this.props.content.accountInterestRegularSaver
          }
        />
        {/* ---More Information---*/}
        <PanelData
          accountId={this.props.accountId}
          account={accountDetails}
          balances={balances}
          onShowMoreClick={this.showMore}
          onFAQAnchorClick={this.onFAQAnchorClick}
          collapsibleButtonName={this.state.collapsibleButtonName}
          iconId={this.state.iconId}
          open={this.state.open}
          content={this.props.content}
        />
        <AERInformation account={accountDetails} />
      </div>
    );
  }
}

AccountCardComponent.propTypes = {
  accountId: PropTypes.string.isRequired,
  onAccountSelect: PropTypes.func.isRequired,
  openCloseMore: PropTypes.func.isRequired,
  /** @note these props only appear in componentWillRecieveProps */
  openMore: PropTypes.bool,
  collapsibleButtonName: PropTypes.string,
  iconId: PropTypes.string,
  /** ---------------------------------------------------------- */
  selectedAccount: PropTypes.string,
  content: PropTypes.object,
};

AccountCardComponent.defaultProps = {
  collapsibleButtonName: 'More',
  content: {},
  selectedAccount: 'current',
};

export default AccountCardComponent;
